export default {
    LOAD_NEWSLETTERS (state, newsletters) {
        state.items = newsletters
    },
}